import {
  selectColumns,
  setHoverDeleteButton,
} from '@databases/redux/cellSelections/actions';
import { appStore } from '@databases/redux/store';

/**
 * Handles the mouse enter event for the delete field button.
 */
export function onMouseEnterDeleteFieldButton(
  contentId: string,
  selectedFieldIds: string[]
) {
  appStore.dispatch(setHoverDeleteButton({ value: 'fields' }));
  appStore.dispatch(
    selectColumns({
      contentId,
      fieldIds: selectedFieldIds,
      clearSelectedValues: false,
    })
  );
}
